import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function WhyHost() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const anim0 = useScrollAnimation({ threshold: 0.1 });
  const anim1 = useScrollAnimation({ threshold: 0.1 });
  const anim2 = useScrollAnimation({ threshold: 0.1 });
  const anim3 = useScrollAnimation({ threshold: 0.1 });

  const cardAnims = [anim0, anim1, anim2, anim3];

  const reasons = [
    {
      icon: 'ri-star-line',
      title: 'Elevate Your Private Gatherings',
      description: 'Transform ordinary events into extraordinary cultural experiences that your guests will remember for years to come.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Offer Unforgettable Cultural Experiences',
      description: 'Give your guests the rare gift of world-class live music in an intimate, personal setting.'
    },
    {
      icon: 'ri-group-line',
      title: 'Create Meaningful Connection',
      description: 'Foster deeper conversations and connections through the shared experience of live artistry.'
    },
    {
      icon: 'ri-building-line',
      title: "Join Nashville's Cultural Renaissance",
      description: 'Become part of a distinguished community reviving the timeless tradition of private salon performances.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 animate-fade-up ${headerVisible ? 'in-view' : ''}`}
        >
          <h2 className="font-serif text-4xl lg:text-5xl text-gray-900 mb-6">
            Why Be a Patron?
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Being a Salon Patron is more than entertainment—it's a statement of cultural refinement and personal distinction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {reasons.map((reason, index) => (
            <div
              key={index}
              ref={cardAnims[index].ref as React.RefObject<HTMLDivElement>}
              className={`flex gap-6 animate-fade-up ${cardAnims[index].isVisible ? 'in-view' : ''}`}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <div className="flex-shrink-0">
                <div className="flex items-center justify-center w-14 h-14 bg-amber-100 rounded-full">
                  <i className={`${reason.icon} text-2xl text-amber-700`}></i>
                </div>
              </div>
              <div>
                <h3 className="font-serif text-2xl text-gray-900 mb-3">{reason.title}</h3>
                <p className="text-gray-700 leading-relaxed">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
